import React, { Component } from 'react';
import './../../Modal.css';
import { users, usersWaivers, usersMemberships, usersAccess } from '../../../../apis/backend';
import { connect } from 'react-redux';
import Select from 'react-select';
import {
  updateSelectedUser,
  updateSelectedUserWaiver
} from '../../../../actions/adminActions/usersActions';
import AutoComplete from '../../../utils/autoComplete/autoComplete';

class EditModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      dateOfBirth: '',
      city: '',
      state: '',
      zipcode: '',
      address1: '',
      address2: '',
      emergencyContact1: '',
      emergencyContact2: '',
      medicalNotes: '',
      pronoun: '',
      gender: '',
      race: '',
      ethnicity: '',
      grade: '',
      school: '',
      reducedLunch: 'No',
      juvenileJustice: 'No',
      allAccess: 0,
      allAccessId: 0,
      collectiveAccess: 0,
      collectiveAccessId: 0,
      // AAP fields (not required)
      respondant: '',
      respondantKnowledge: '',
      respondantMentioner: '',
      applicantBenefit: '',
      applicantInterests: '',
      mentoring: 0,
      transportationMode: '',
      digitalArtInterests: '',
      guardianName: '',
      guardianRelationship: '',
      guardianPhone: '',
      guardianEmail: '',
      guardianAddress: '',
      rejectNotes: ''
    };
  }

  async approveWaiver() {
    const aapFields = {};
    if (this.state.allAccess) {
      aapFields.respondant = this.state.respondant;
      aapFields.respondantKnowledge = this.state.respondantKnowledge;
      aapFields.respondantMentioner = this.state.respondantMentioner;
      aapFields.applicantBenefit = this.state.applicantBenefit;
      aapFields.applicantInterests = this.state.applicantInterests;
      aapFields.mentoring = this.state.mentoring;
      aapFields.transportationMode = this.state.transportationMode;
      aapFields.digitalArtInterests = this.state.digitalArtInterests;
      aapFields.guardianName = this.state.guardianName;
      aapFields.guardianRelationship = this.state.guardianRelationship;
      aapFields.guardianPhone = this.state.guardianPhone;
      aapFields.guardianEmail = this.state.guardianEmail;
      aapFields.guardianAddress = this.state.guardianAddress;
    }
    await users
      .patch(
        `/${this.props.selectedUser}`,
        {
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          dateOfBirth: this.state.dateOfBirth,
          phoneNumber: this.state.phone,
          city: this.state.city,
          state: this.state.state,
          zipcode: this.state.zipcode,
          address1: this.state.address1,
          address2: this.state.address2,
          email: this.state.email,
          emergencyContact1: this.state.emergencyContact1,
          emergencyContact2: this.state.emergencyContact2,
          medicalNotes: this.state.medicalNotes,
          pronoun: this.state.pronoun,
          gender: this.state.gender,
          race: this.state.race,
          ethnicity: this.state.ethnicity,
          grade: this.state.grade,
          school: this.state.school,
          aapData: JSON.stringify(aapFields),
          reducedLunch: this.state.reducedLunch?.value,
          juvenileJustice: this.state.juvenileJustice?.value
        },
        { headers: { authorization: this.props.employeeToken } }
      )
      .catch((response) => {
        console.log(response);
      });
    const uw = this.props.usersWaivers.find((uw) => uw.id == this.props.selectedWaiver);
    const employee = this.props.employees.find((emp) => {
      return emp.id == this.props.empId;
    });

    let newExpiryDate = new Date(
      new Date(uw.expiry).getFullYear() + 1,
      new Date(uw.expiry).getMonth(),
      new Date(uw.expiry).getDate()
    );

    await usersWaivers
      .patch(`/${uw.id}`, {
        status: 'approved',
        updatedBy: employee.firstName + ' ' + employee.lastName,
        expiry: newExpiryDate
      })
      .catch((response) => {
        console.log(response);
      });

    if (this.state.allAccessId !== 0 && this.state.allAccess === 0) {
      // Expire All Access Pass
      await usersMemberships
        .patch(
          `/expire/${this.state.allAccessId}`,
          {},
          { headers: { authorization: this.props.employeeToken } }
        )
        .then(() => this.setState({ allAccess: 0, allAccessId: 0 }))
        .catch((err) => console.log(err));
    } else if (this.state.allAccessId === 0 && this.state.allAccess !== 0) {
      // Create All Access Pass
      const allAccess = this.props.memberships.find((obj) => obj.accessName === 'All Access Pass');
      await usersMemberships
        .post(
          '/',
          {
            user: this.props.selectedUser,
            membership: allAccess.id
          },
          { headers: { authorization: this.props.employeeToken } }
        )
        .then(() => this.setState({ allAccess: 0, allAccessId: 0 }))
        .catch((err) => console.log(err));
    }

    if (this.state.collectiveAccessId !== 0 && this.state.collectiveAccess === 0) {
      // Expire Collective Access
      await usersAccess
        .patch(
          `/expire/${this.state.collectiveAccessId}`,
          {},
          { headers: { authorization: this.props.employeeToken } }
        )
        .then(() => this.setState({ collectiveAccess: 0, collectiveAccessId: 0 }))
        .catch((err) => console.log(err));
    } else if (this.state.collectiveAccessId === 0 && this.state.collectiveAccess !== 0) {
      // Create Collective Access
      const collectiveAccess = this.props.access.find((obj) => obj.name === 'Collective Access');
      await usersAccess
        .post(
          '/',
          {
            user: this.props.selectedUser,
            access: collectiveAccess.id
          },
          { headers: { authorization: this.props.employeeToken } }
        )
        .then(() => this.setState({ collectiveAccess: 0, collectiveAccessId: 0 }))
        .catch((err) => console.log(err));
    }

    this.props.updateSelectedUser(0);
    this.props.updateSelectedUserWaiver(0);
  }

  async rejectWaiver() {
    const aapFields = {};
    if (this.state.allAccess) {
      aapFields.respondant = this.state.respondant;
      aapFields.respondantKnowledge = this.state.respondantKnowledge;
      aapFields.respondantMentioner = this.state.respondantMentioner;
      aapFields.applicantBenefit = this.state.applicantBenefit;
      aapFields.applicantInterests = this.state.applicantInterests;
      aapFields.mentoring = this.state.mentoring;
      aapFields.transportationMode = this.state.transportationMode;
      aapFields.digitalArtInterests = this.state.digitalArtInterests;
      aapFields.guardianName = this.state.guardianName;
      aapFields.guardianRelationship = this.state.guardianRelationship;
      aapFields.guardianPhone = this.state.guardianPhone;
      aapFields.guardianEmail = this.state.guardianEmail;
      aapFields.guardianAddress = this.state.guardianAddress;
    }
    await users
      .patch(
        `/${this.props.selectedUser}`,
        {
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          dateOfBirth: this.state.dateOfBirth,
          phoneNumber: this.state.phone,
          city: this.state.city,
          state: this.state.state,
          zipcode: this.state.zipcode,
          address1: this.state.address1,
          address2: this.state.address2,
          email: this.state.email,
          emergencyContact1: this.state.emergencyContact1,
          emergencyContact2: this.state.emergencyContact2,
          medicalNotes: this.state.medicalNotes,
          pronoun: this.state.pronoun,
          gender: this.state.gender,
          race: this.state.race,
          ethnicity: this.state.ethnicity,
          grade: this.state.grade,
          school: this.state.school,
          aapData: JSON.stringify(aapFields),
          reducedLunch: this.state.reducedLunch?.value,
          juvenileJustice: this.state.juvenileJustice?.value
        },
        { headers: { authorization: this.props.employeeToken } }
      )
      .catch((response) => {
        console.log(response);
      });

    const uw = this.props.usersWaivers.find((uw) => uw.id == this.props.selectedWaiver);
    const employee = this.props.employees.find((emp) => {
      return emp.id == this.props.empId;
    });

    await usersWaivers
      .patch(`/${uw.id}`, {
        status: 'rejected',
        updatedBy: employee.firstName + ' ' + employee.lastName,
        notes: this.state.rejectNotes
      })
      .catch((response) => {
        console.log(response);
      });

    if (this.state.allAccessId !== 0 && this.state.allAccess === 0) {
      // Expire All Access Pass
      await usersMemberships
        .patch(
          `/expire/${this.state.allAccessId}`,
          {},
          { headers: { authorization: this.props.employeeToken } }
        )
        .then(() => this.setState({ allAccess: 0, allAccessId: 0 }))
        .catch((err) => console.log(err));
    } else if (this.state.allAccessId === 0 && this.state.allAccess !== 0) {
      // Create All Access Pass
      const allAccess = this.props.memberships.find((obj) => obj.accessName === 'All Access Pass');
      await usersMemberships
        .post(
          '/',
          {
            user: this.props.selectedUser,
            membership: allAccess.id
          },
          { headers: { authorization: this.props.employeeToken } }
        )
        .then(() => this.setState({ allAccess: 0, allAccessId: 0 }))
        .catch((err) => console.log(err));
    }

    if (this.state.collectiveAccessId !== 0 && this.state.collectiveAccess === 0) {
      // Expire Collective Access
      await usersAccess
        .patch(
          `/expire/${this.state.collectiveAccessId}`,
          {},
          { headers: { authorization: this.props.employeeToken } }
        )
        .then(() => this.setState({ collectiveAccess: 0, collectiveAccessId: 0 }))
        .catch((err) => console.log(err));
    } else if (this.state.collectiveAccessId === 0 && this.state.collectiveAccess !== 0) {
      // Create Collective Access
      const collectiveAccess = this.props.access.find((obj) => obj.name === 'Collective Access');
      await usersAccess
        .post(
          '/',
          {
            user: this.props.selectedUser,
            access: collectiveAccess.id
          },
          { headers: { authorization: this.props.employeeToken } }
        )
        .then(() => this.setState({ collectiveAccess: 0, collectiveAccessId: 0 }))
        .catch((err) => console.log(err));
    }

    this.props.updateSelectedUser(0);
    this.props.updateSelectedUserWaiver(0);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.selectedUser !== this.props.selectedUser && this.props.selectedUser !== 0) {
      const user = this.props.users.find((obj) => obj.id === this.props.selectedUser);
      if (user) {
        const aapFields = user.aapData === '' ? {} : JSON.parse(user.aapData);
        this.setState({
          firstName: user.firstName,
          lastName: user.lastName,
          phone: user.phoneNumber,
          email: user.email,
          dateOfBirth: user.dateOfBirth,
          city: user.city,
          state: user.state,
          zipcode: user.zipcode,
          address1: user.address1,
          address2: user.address2,
          emergencyContact1: user.emergencyContact1,
          emergencyContact2: user.emergencyContact2,
          medicalNotes: user.medicalNotes,
          pronoun: user.pronoun,
          gender: user.gender ? user.gender : '',
          race: user.race ? user.race : '',
          ethnicity: user.ethnicity ? user.ethnicity : '',
          grade: user.grade ? user.grade : '',
          school: user.school ? user.school : '',
          // AAP fields
          respondant: aapFields.respondant ? aapFields.respondant : '',
          respondantKnowledge: aapFields.respondantKnowledge ? aapFields.respondantKnowledge : '',
          respondantMentioner: aapFields.respondantMentioner ? aapFields.respondantMentioner : '',
          applicantBenefit: aapFields.applicantBenefit ? aapFields.applicantBenefit : '',
          reducedLunch: user.reducedLunch ? user.reducedLunch : '',
          juvenileJustice: user.juvenileJustice ? user.juvenileJustice : '',
          applicantInterests: aapFields.applicantInterests ? aapFields.applicantInterests : '',
          mentoring: aapFields.mentoring ? aapFields.mentoring : '',
          transportationMode: aapFields.transportationMode ? aapFields.transportationMode : '',
          digitalArtInterests: aapFields.digitalArtInterests ? aapFields.digitalArtInterests : '',
          guardianName: aapFields.guardianName ? aapFields.guardianName : '',
          guardianRelationship: aapFields.guardianRelationship
            ? aapFields.guardianRelationship
            : '',
          guardianPhone: aapFields.guardianPhone ? aapFields.guardianPhone : '',
          guardianEmail: aapFields.guardianEmail ? aapFields.guardianEmail : '',
          guardianAddress: aapFields.guardianAddress ? aapFields.guardianAddress : ''
        });
        const selectOptions = [
          { label: 'Yes', value: 'Yes' },
          { label: 'No', value: 'No' },
          { label: 'Unknown/Prefer not to Answer', value: 'Unknown/Prefer not to Answer' }
        ];
        let juvenileJusticeIndex =
          user.juvenileJustice && user.juvenileJustice === 'Yes'
            ? 0
            : user.juvenileJustice === 'No'
              ? 1
              : user.juvenileJustice === 'Unknown/Prefer not to Answer'
                ? 2
                : null;
        this.setState({
          juvenileJustice: juvenileJusticeIndex != null ? selectOptions[juvenileJusticeIndex] : null
        });
        let reducedLunchIndex =
          user.reducedLunch && user.reducedLunch === 'Yes'
            ? 0
            : user.reducedLunch === 'No'
              ? 1
              : user.reducedLunch === 'Unknown/Prefer not to Answer'
                ? 2
                : null;
        this.setState({
          reducedLunch: reducedLunchIndex != null ? selectOptions[reducedLunchIndex] : null
        });
      }

      this.setInitialPermissions();
    }
  }

  async setInitialPermissions() {
    const current = new Date();

    // All Access Pass
    const allAccess = this.props.memberships.find((obj) => obj.accessName === 'All Access Pass');
    const userMembership = await usersMemberships
      .get('/find', {
        headers: {
          authorization: this.props.employeeToken
        },
        params: {
          user: this.props.selectedUser,
          membership: allAccess.id
        }
      })
      .catch((response) => {
        console.log(response);
      });
    if (
      !(
        !userMembership.data.length > 0 ||
        new Date(userMembership.data[0].endTime).getTime() < current.getTime()
      )
    ) {
      this.setState({
        allAccess: 1,
        allAccessId: userMembership.data[0].id
      });
    } else {
      this.setState({
        allAccess: 0,
        allAccessId: 0
      });
    }

    // Collective Access
    const collectiveAccess = this.props.access.find((obj) => obj.name === 'Collective Access');
    const userAccess = await usersAccess
      .get('/find', {
        headers: { authorization: this.props.employeeToken },
        params: {
          user: this.props.selectedUser,
          access: collectiveAccess.id
        }
      })
      .catch((response) => {
        console.log(response);
      });
    if (
      !(
        !userAccess.data.length > 0 ||
        new Date(userAccess.data[0].endTime).getTime() < current.getTime()
      )
    ) {
      this.setState({
        collectiveAccess: 1,
        collectiveAccessId: userAccess.data[0].id
      });
    } else {
      this.setState({
        collectiveAccess: 0,
        collectiveAccessId: 0
      });
    }
  }

  waiverStatus(user) {
    if (user?.smartWaiver) {
      const timeRemaining = new Date(user.smartWaiver).getTime() - new Date().getTime();
      if (timeRemaining <= 0) {
        return 'Expired on ' + new Date(user.smartWaiver).toDateString();
      } else {
        return 'Valid till ' + new Date(user.smartWaiver).toDateString();
      }
    } else {
      return 'Not filled out!';
    }
  }

  rfidStatus(user) {
    if (user?.rfid && user?.rfid !== '') {
      return `${user.rfid}`;
    } else {
      return 'None Assigned!';
    }
  }

  juvenileJusticeStatus(user) {
    if (user?.juvenileJustice && user?.juvenileJustice !== '') {
      return `${user.juvenileJustice}`;
    } else {
      return 'Unknown';
    }
  }

  renderAAPFields() {
    if (this.state.allAccess) {
      return (
        <>
          <hr />
          <div className="input-group input-group-sm mb-3">
            <strong>AAP Fields</strong>
          </div>
          <div className="input-group input-group-sm mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Who filled out the form?
              </span>
            </div>
            <input
              type="text"
              className="form-control"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              value={this.state.respondant}
              placeholder="..."
              onChange={(e) => this.setState({ respondant: e.target.value })}
            />
          </div>
          <div className="input-group input-group-sm mb-3" style={{ display: 'block' }}>
            <div className="input-group-prepend">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                How did they find out about this form?
              </span>
            </div>
            <textarea
              type="text"
              className="form-control"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              value={this.state.respondantKnowledge}
              placeholder="..."
              onChange={(e) => this.setState({ respondantKnowledge: e.target.value })}
            />
          </div>
          <div className="input-group input-group-sm mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Who told them about the All-Access Pass?
              </span>
            </div>
            <input
              type="text"
              className="form-control"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              value={this.state.respondantMentioner}
              placeholder="..."
              onChange={(e) => this.setState({ respondantMentioner: e.target.value })}
            />
          </div>
          <div className="input-group input-group-sm mb-3" style={{ display: 'block' }}>
            <div className="input-group-prepend">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Why would the applicant benefit from having an All-Access Pass?
              </span>
            </div>
            <textarea
              type="text"
              className="form-control"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              value={this.state.applicantBenefit}
              placeholder="..."
              onChange={(e) => this.setState({ applicantBenefit: e.target.value })}
            />
          </div>
          <div className="input-group input-group-sm mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Does the applicant qualify for free and reduced school meals?
              </span>
            </div>
            <select
              className="form-control"
              value={this.state.reducedLunch}
              onChange={(e) => this.setState({ reducedLunch: parseInt(e.target.value) })}
            >
              <option value={0}>No</option>
              <option value={1}>Yes</option>
            </select>
          </div>
          <div className="input-group input-group-sm mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Is the applicant involved in the Juvenile Justice System?
              </span>
            </div>
            <select
              className="form-control"
              value={this.state.juvenileJustice}
              onChange={(e) => this.setState({ juvenileJustice: parseInt(e.target.value) })}
            >
              <option value="No">No</option>
              <option value="Yes">Yes</option>
              <option value="Unknown/Prefer Not to Answer">Unknown/Prefer Not to Answer</option>
            </select>
          </div>
          <div className="input-group input-group-sm mb-3" style={{ display: 'block' }}>
            <div className="input-group-prepend">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Applicant&apos;s areas of interest at The Bay
              </span>
            </div>
            <textarea
              type="text"
              className="form-control"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              value={this.state.applicantInterests}
              placeholder="..."
              onChange={(e) => this.setState({ applicantInterests: e.target.value })}
            />
          </div>
          <div className="input-group input-group-sm mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Is the applicant interested in any mentoring?
              </span>
            </div>
            <select
              className="form-control"
              value={this.state.mentoring}
              onChange={(e) => this.setState({ mentoring: parseInt(e.target.value) })}
            >
              <option value={0}>No</option>
              <option value={1}>Yes</option>
            </select>
          </div>
          <div className="input-group input-group-sm mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                How will the applicant travel to/from The Bay?
              </span>
            </div>
            <input
              type="text"
              className="form-control"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              value={this.state.transportationMode}
              placeholder="..."
              onChange={(e) => this.setState({ transportationMode: e.target.value })}
            />
          </div>
          <div className="input-group input-group-sm mb-3" style={{ display: 'block' }}>
            <div className="input-group-prepend">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Applicant&apos;s digital art interests?
              </span>
            </div>
            <textarea
              type="text"
              className="form-control"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              value={this.state.digitalArtInterests}
              placeholder="..."
              onChange={(e) => this.setState({ digitalArtInterests: e.target.value })}
            />
          </div>
          <div className="input-group input-group-sm mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Parent / Guardian Full Name
              </span>
            </div>
            <input
              type="text"
              className="form-control"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              value={this.state.guardianName}
              placeholder="..."
              onChange={(e) => this.setState({ guardianName: e.target.value })}
            />
          </div>
          <div className="input-group input-group-sm mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Parent / Guardian Relationship
              </span>
            </div>
            <input
              type="text"
              className="form-control"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              value={this.state.guardianRelationship}
              placeholder="..."
              onChange={(e) => this.setState({ guardianRelationship: e.target.value })}
            />
          </div>
          <div className="input-group input-group-sm mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Parent / Guardian Phone Number
              </span>
            </div>
            <input
              type="tel"
              className="form-control"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              value={this.state.guardianPhone}
              placeholder="Phone #"
              onChange={(e) => this.setState({ guardianPhone: e.target.value })}
            />
          </div>
          <div className="input-group input-group-sm mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Parent / Guardian Email
              </span>
            </div>
            <input
              type="text"
              className="form-control"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              value={this.state.guardianEmail}
              placeholder="Email"
              onChange={(e) => this.setState({ guardianEmail: e.target.value })}
            />
          </div>
          <div className="input-group input-group-sm mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Parent / Guardian Address
              </span>
            </div>
            <input
              type="text"
              className="form-control"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              value={this.state.guardianAddress}
              placeholder="Email"
              onChange={(e) => this.setState({ guardianAddress: e.target.value })}
            />
          </div>
        </>
      );
    }
  }

  render() {
    const selectOptions = [
      { label: 'Yes', value: 'Yes' },
      { label: 'No', value: 'No' },
      { label: 'Unknown/Prefer not to Answer', value: 'Unknown/Prefer not to Answer' }
    ];
    const user = this.props.users.find((obj) => obj.id === this.props.selectedUser);
    return (
      <div id="editModal" className="modal fade" style={{ overflow: 'scroll' }}>
        <div className="modal-dialog modal-dialog-centered lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Review Waiver</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => this.props.updateSelectedUser(0)}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="table-wrapper-scroll-y" style={{ maxHeight: '550px' }}>
                <div className="input-group input-group-sm mb-3">
                  <strong>RFID:</strong>&nbsp;{this.rfidStatus(user)}
                </div>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      First Name <span className="required">*</span>
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={this.state.firstName}
                    placeholder="First Name"
                    onChange={(e) => this.setState({ firstName: e.target.value })}
                  />
                </div>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      Last Name <span className="required">*</span>
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={this.state.lastName}
                    placeholder="Last Name"
                    onChange={(e) => this.setState({ lastName: e.target.value })}
                  />
                </div>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      Birthdate <span className="required">*</span>
                    </span>
                  </div>
                  <input
                    type="date"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={this.state.dateOfBirth.split('T')[0]}
                    placeholder="Last Name"
                    onChange={(e) => this.setState({ dateOfBirth: e.target.value })}
                  />
                </div>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      Email <span className="required">*</span>
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={this.state.email}
                    placeholder="Email"
                    onChange={(e) => this.setState({ email: e.target.value })}
                  />
                </div>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      Phone # <span className="required">*</span>
                    </span>
                  </div>
                  <input
                    type="tel"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={this.state.phone}
                    placeholder="Phone #"
                    onChange={(e) => this.setState({ phone: e.target.value })}
                  />
                </div>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      City <span className="required">*</span>
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={this.state.city}
                    placeholder="City"
                    onChange={(e) => this.setState({ city: e.target.value })}
                  />
                </div>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      State <span className="required">*</span>
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={this.state.state}
                    placeholder="State"
                    onChange={(e) => this.setState({ state: e.target.value })}
                  />
                </div>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      Zipcode <span className="required">*</span>
                    </span>
                  </div>
                  <input
                    type="Number"
                    min="0"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={this.state.zipcode}
                    placeholder="Zipcode"
                    onChange={(e) => this.setState({ zipcode: e.target.value })}
                  />
                </div>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      Address Line 1 <span className="required">*</span>
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={this.state.address1}
                    placeholder="Address #1"
                    onChange={(e) => this.setState({ address1: e.target.value })}
                  />
                </div>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      Address Line 2
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={this.state.address2}
                    placeholder="Address #2"
                    onChange={(e) => this.setState({ address2: e.target.value })}
                  />
                </div>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      Emergency Contact Name <span className="required">*</span>
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={this.state.emergencyContact1}
                    placeholder="Jon Doe"
                    onChange={(e) => this.setState({ emergencyContact1: e.target.value })}
                  />
                </div>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      Emergency Contact # <span className="required">*</span>
                    </span>
                  </div>
                  <input
                    type="tel"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={this.state.emergencyContact2}
                    placeholder="(123) 456-7890"
                    onChange={(e) => this.setState({ emergencyContact2: e.target.value })}
                  />
                </div>
                <AutoComplete
                  isMultiple={false}
                  minSearchLength={0}
                  csvRoute={'/data/pronouns.csv'}
                  dataLabel={'Pronoun'}
                  inputLabel={'Pronoun'}
                  onOptionSelect={(e) => {
                    this.setState({ pronoun: e });
                  }}
                  initialInputValue={this.state.pronoun}
                />
                <AutoComplete
                  isMultiple={true}
                  minSearchLength={0}
                  csvRoute={'/data/genders.csv'}
                  dataLabel={'Gender'}
                  inputLabel={'Genders'}
                  onOptionSelect={(e) => {
                    this.setState({ gender: e.join(', ') });
                  }}
                  initialInputValue={this.state.gender != '' ? this.state.gender.split(', ') : ''}
                />
                <AutoComplete
                  isMultiple={false}
                  minSearchLength={0}
                  csvRoute={'/data/races.csv'}
                  dataLabel={'Race'}
                  inputLabel={'Race'}
                  onOptionSelect={(e) => {
                    this.setState({ race: e });
                  }}
                  initialInputValue={this.state.race}
                />
                <AutoComplete
                  isMultiple={true}
                  minSearchLength={0}
                  csvRoute={'/data/ethnicities.csv'}
                  dataLabel={'Ethnicity'}
                  inputLabel={'Ethnicities'}
                  onOptionSelect={(e) => {
                    this.setState({ ethnicity: e.join(', ') });
                  }}
                  initialInputValue={
                    this.state.ethnicity != '' ? this.state.ethnicity.split(', ') : ''
                  }
                />
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      Grade
                    </span>
                  </div>
                  <input
                    type="number"
                    max="12"
                    min="1"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={this.state.grade}
                    placeholder="Grade"
                    onChange={(e) => this.setState({ grade: e.target.value })}
                  />
                </div>
                <AutoComplete
                  isMultiple={false}
                  minSearchLength={3}
                  inputLabel={'School'}
                  csvRoute={'/data/nde-directory.csv'}
                  dataLabel={'SCHOOL NAME'}
                  onOptionSelect={(e) => {
                    this.setState({ school: e });
                  }}
                  initialInputValue={this.state.school}
                />
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      Free or Reduced Lunch
                    </span>
                  </div>
                  <Select
                    placeholder="select an option"
                    className="multiselector"
                    value={this.state.reducedLunch}
                    options={selectOptions}
                    onChange={(e) => {
                      this.setState({ reducedLunch: e });
                    }}
                  />
                </div>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      Juvenile Justice System
                    </span>
                  </div>
                  <Select
                    placeholder="select an option"
                    className="multiselector"
                    value={this.state.juvenileJustice}
                    options={selectOptions}
                    onChange={(e) => {
                      this.setState({ juvenileJustice: e });
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => this.props.updateSelectedUser(0)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-dark"
                data-dismiss="modal"
                onClick={() => {
                  this.approveWaiver();
                }}
                disabled={
                  !(
                    this.state.firstName !== '' &&
                    this.state.lastName !== '' &&
                    this.state.dateOfBirth !== '' &&
                    this.state.address != '' &&
                    this.state.city !== '' &&
                    this.state.state !== '' &&
                    this.state.zipcode >= 0 &&
                    this.state.emergencyContact1 !== '' &&
                    this.state.emergencyContact2 !== '' &&
                    this.state.email !== '' &&
                    this.state.phone !== ''
                  )
                }
              >
                Approve
              </button>
              <button
                type="button"
                className="btn btn-danger"
                data-dismiss="modal"
                onClick={() => {
                  this.rejectWaiver();
                }}
                disabled={!(this.state.rejectNotes !== '')}
              >
                Reject
              </button>
            </div>
            <div className="modal-body">
              <div className="input-group-prepend mb-2">
                <span className="input-group-text" id="inputGroup-sizing-sm">
                  Reject Reason
                </span>
              </div>
              <textarea
                type="text"
                className="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                value={this.state.rejectNotes}
                placeholder="Reject Reason"
                onChange={(e) => this.setState({ rejectNotes: e.target.value })}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  users: state.admin.admin.users,
  usersWaivers: state.admin.admin.usersWaivers,
  employees: state.admin.admin.employees,
  empId: state.auth.empId,
  selectedUser: state.admin.users.selectedUser,
  selectedWaiver: state.admin.users.selectedWaiver,
  memberships: state.admin.admin.memberships,
  access: state.admin.admin.access,
  employeeToken: state.auth.employeeToken
});

export default connect(mapStateToProps, { updateSelectedUser, updateSelectedUserWaiver })(
  EditModal
);
